import PropTypes from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';

function BoardCard({ organizationName, content }) {
  return (
    <Card sx={{ border: '1px solid #d3d4d5', my: 4 }}>
      <CardContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {content}
        </Typography>
        <Typography variant="button" sx={{ ml: 1, color: 'grey.500', textTransform: 'none', fontSize: 13 }}>
          {organizationName}
        </Typography>
      </CardContent>
    </Card>
  );
}

BoardCard.propTypes = {
  organizationName: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default BoardCard;
